import type { CheckpointField as CheckpointFieldType } from '@certhon/models';
import { useListContext, useFieldActions } from '../context';
import { AnnotationIndicators } from './AnnotationIndicators';
import { CheckpointControl } from './CheckpointControl';
import { FieldFeedbackBadge } from '@/features/feedback/components/FieldFeedbackBadge';
import { FieldTitle } from './FieldTitle';
import { FieldWrapper } from './FieldWrapper';

interface CheckpointFieldProps {
  field: CheckpointFieldType;
  isActive?: boolean;
  isEven?: boolean;
  onSelect?: (fieldId: string) => void;
}

export function CheckpointField({
  field,
  isActive,
  isEven,
  onSelect,
}: CheckpointFieldProps) {
  const { mode } = useListContext();
  const actions = useFieldActions(field.id);

  const disabled = mode === 'view';

  return (
    <FieldWrapper
      fieldId={field.id}
      isActive={isActive}
      isEven={isEven}
      onClick={onSelect ? () => onSelect(field.id) : undefined}
    >
      <FieldTitle field={field} />
      <AnnotationIndicators attachments={field.attachments} />
      <FieldFeedbackBadge fieldId={field.id} size="small" />
      <CheckpointControl
        value={field.value}
        onChange={(v) => actions.patch({ value: v })}
        disabled={disabled}
      />
    </FieldWrapper>
  );
}
